import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/main.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import { storyblokInit, apiPlugin } from '@storyblok/react';
import Page from './components/Page';
import Teaser from './components/Teaser';
import Feature from './components/Feature';
import Stage from './components/modules/Stage';

import HeaderMenu from './components/HeaderMenu';
import MenuLink from './components/MenuLink';
import Team from './components/modules/Team';
import Showcase from './components/modules/ShowCase';
import CopyCenter from './components/modules/CopyCenter';
import Split from './components/modules/Split';
import LookBook from './components/modules/LookBook';
import ProjectDetails from './components/ProjectDetails';
import WokingAtAE from './components/modules/WorkingAtAE';
import Benefits from './components/modules/Benefits';
import JobList from './components/modules/JobList';
import JobDetails from './components/modules/JobDetails';
import Form from './components/Form';
import FooterMenu from './components/FooterMenu';
import { Services } from './components/modules/Services';
import GenericRichText from './components/base/GenericRichText';
import GenericTitle from './components/base/GenericTitle';
import ErrorBoundary from './components/ErrorBoundary';
import SinglePdf from './components/base/SinglePdf';
import { OverlayTrigger } from './components/modules/OverlayTrigger';
import Apparel from './components/modules/Apparel';
import ECommerceDetail from './components/modules/ECommerceDetail';

storyblokInit({
  accessToken: '4zh3ILfpd0uScORg1kM9jAtt', // Space -> Settings -> Access Token -> Preview
  use: [apiPlugin],
  components: {
    apparel: Apparel,
    benefits: Benefits,
    feature: Feature,
    footer_menu: FooterMenu,
    form: Form,
    generic_rich_text: GenericRichText,
    generic_title: GenericTitle,
    header_menu: HeaderMenu,
    job_banner: CopyCenter,
    job_details: JobDetails,
    job_list: JobList,
    lookbook: LookBook,
    menu_link: MenuLink,
    overlay_trigger: OverlayTrigger,
    page: Page,
    project_details: ProjectDetails,
    services: Services,
    showcase: Showcase,
    single_pdf: SinglePdf,
    split: Split,
    stage: Stage,
    team: Team,
    teaser: Teaser,
    working_at_AE: WokingAtAE,
    ecommerce_detail: ECommerceDetail,
  },
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <Router>
    <React.StrictMode>
      <HelmetProvider>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </HelmetProvider>
    </React.StrictMode>
  </Router>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
